import { render } from "./CadastrarModeloMaterial.vue?vue&type=template&id=3360b381"
import script from "./CadastrarModeloMaterial.vue?vue&type=script&lang=js"
export * from "./CadastrarModeloMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__